import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from './app-routing-auth-guard';
import { RedirectGuard } from './app-routing-redirect-guard';

import { LoginComponent } from './login/login.component';
import { AuthorizationComponent } from './login/authorization.component';

import { ApplicationHomeComponent } from './grant/application-home.component';
import { ApplicationComponent } from './grant/application.component';
import { ApplicationResolver } from './grant/application-resolver.service';

import { TrainingComponent } from './training/training.component';
import { ResourcesComponent } from './resources/resources.component';
import { DirectoryComponent } from './directory/directory.component';
import { MaterialComponent } from './material/material.component';
import { ContactEbbComponent } from './contact/contact-ebb.component';
import { ProgramCycleResolver } from './grant/programcycle-resolver.service';
import { ActivateComponent } from './login/activate/activate.component';
import { LoadingComponent } from './loading/loading.component';
import { ImpersonateComponent } from './login/impersonate.component';
import { TrainingEBBComponent } from './training-ebb/training-ebb.component';
import { TrainingESSComponent } from './training-ess/training-ess.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'home'
        },
        {
          path: 'login',
          component: LoginComponent
        },
        {
          path: 'impersonate',
          component: ImpersonateComponent
        },
        {
          path: 'activate',
          component: ActivateComponent
        },
        {
          path: 'authorization',
          component: AuthorizationComponent
        },
        {
          path: 'home',
          component: ApplicationHomeComponent,
          pathMatch: 'full',
          canActivate: [AuthGuard],
          resolve: {
            programCycles: ProgramCycleResolver
          },
          runGuardsAndResolvers: 'always'
        },
        {
          path: 'login/:email:status',
          component: LoginComponent
        },
        {
          path: 'application/:id',
          runGuardsAndResolvers: 'always',
          component: ApplicationComponent,
          canActivate: [AuthGuard],
          resolve: {
            options: ApplicationResolver,
            programCycles: ProgramCycleResolver
          }
        },
        {
          path: 'account',
          loadChildren: () => import('./account/user-account.module').then(m => m.UserAccountModule),
          canActivate: [AuthGuard]
        },
        {
          path: 'train',
          component: TrainingComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'trainingebb',
          component: TrainingEBBComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'trainingess',
          component: TrainingESSComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'resources',
          component: ResourcesComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'directory',
          component: DirectoryComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'material',
          component: MaterialComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'contact',
          component: ContactEbbComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'loading',
          component: LoadingComponent,
          canActivate: [AuthGuard]
        },
        {
          path: '**',
          redirectTo: 'home'
        }
      ],
      {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled'
      }
    )
  ],
  exports: [RouterModule],
  providers: [ApplicationResolver]
})
export class AppRoutingModule {}
